export const EVENTS = {
  CURATOR_LINK_OPEN_IN_APP_CLICKED: 'curator_link_open_in_app_clicked',

  // PDP V2 Tracking
  PDP_V2_VIEW: 'pdp_v2_view',
  PDP_V2_BUY_NOW_CLICK: 'pdp_v2_buy_now_click',
  PDP_V2_SHARE_CLICK: 'pdp_v2_share_click',
  PDP_V2_TRY_ON_CLICK: 'pdp_v2_try_on_click',
  PDP_V2_SIZE_SHEET_OPEN: 'pdp_v2_size_sheet_open',
  PDP_V2_SIZE_SELECTED: 'pdp_v2_size_selected',
  PDP_V2_SIZE_SHEET_CLOSE: 'pdp_v2_size_sheet_close',
  PDP_V2_SIZE_SHEET_CONTINUE: 'pdp_v2_size_sheet_continue',
  PDP_V2_REEL_CLICK: 'pdp_v2_reel_click',
  PDP_V2_POLICY_ACCORDION_CLICK: 'pdp_v2_policy_accordion_click',

  // New PDP V2 Events
  PDP_V2_REEL_CARD_VIEWED: 'pdp_v2_reel_card_viewed',
  PDP_V2_REVIEW_CARD_VIEWED: 'pdp_v2_review_card_viewed',
  PDP_V2_REEL_OPEN: 'pdp_v2_reel_open',
  PDP_V2_REEL_PLAYBACK_TOGGLE: 'pdp_v2_reel_playback_toggle',
  PDP_V2_REEL_VIEWED: 'pdp_v2_reel_viewed',
  PDP_V2_CAROUSEL_SWIPE: 'pdp_v2_carousel_swipe',
  PDP_V2_CAROUSEL_IMAGE_CLICK: 'pdp_v2_carousel_image_click',
  PDP_V2_VIEW_SIZE_CHART_CLICK: 'pdp_v2_view_size_chart_click',
  PDP_V2_DESCRIPTION_ACCORDION_TOGGLE: 'pdp_v2_description_accordion_toggle',
  PDP_V2_VIEW_MORE_REVIEWS_CLICK: 'pdp_v2_view_more_reviews_click',
  PDP_V2_URL_PARAMS: 'pdp_v2_url_params',
  PDP_V2_HEADER_STORE_CLICK: 'pdp_v2_header_store_click',
  PDP_V2_HEADER_STORE_CLICK_FAILED: 'pdp_v2_header_store_click_failed',
  ORDER_PLACED_HEADER_STORE_CLICK: 'order_placed_header_store_click',
  ORDER_PLACED_HEADER_STORE_CLICK_FAILED:
    'order_placed_header_store_click_failed',
  CURATOR_STORE_VALIDATION: 'curator_store_validation',
  CURATOR_STORE_ERROR_CTA_CLICK: 'curator_store_error_cta_click',
  PDP_V2_REDIRECT_TO_V1: 'pdp_v2_redirect_to_v1',
  PDP_V1_REDIRECT_TO_V2: 'pdp_v1_redirect_to_v2',
  CURATOR_STORE_VIEW: 'curator_store_view',
  CURATOR_STORE_PRODUCT_CLICK: 'curator_store_product_click',
  CURATOR_STORE_LOAD_FAILED: 'curator_store_load_failed',
  PRODUCT_VIEW: 'product view',

  // New PDP V2 Additions
  PDP_V2_FOOTER_SOCIAL_CLICK: 'pdp_v2_footer_social_click',
  PDP_V2_ZOOMABLE_CAROUSEL_OPEN: 'pdp_v2_zoomable_carousel_open',
  PDP_V2_ZOOMABLE_CAROUSEL_SWIPE: 'pdp_v2_zoomable_carousel_swipe',
  PDP_V2_ZOOMABLE_CAROUSEL_ZOOM: 'pdp_v2_zoomable_carousel_zoom',
  PDP_V2_ZOOMABLE_CAROUSEL_CLOSE: 'pdp_v2_zoomable_carousel_close',
  PDP_V2_LOAD_FAILED: 'pdp_v2_load_failed',
  REVIEWS_LOAD_FAILED: 'reviews_load_failed',

  // Razorpay Web Hook / Flow Tracking
  ORDER_CREATED: 'order_created',
  RAZORPAY_OPENED: 'razorpay_opened',
  RAZORPAY_SUCCESS: 'razorpay_success',
  PAYMENT_CONFIRMED: 'payment_confirmed',
  RAZORPAY_CANCELLED: 'razorpay_cancelled',
  ORDER_CREATE_FAILED: 'order_create_failed',
  RAZORPAY_FAILURE: 'razorpay_failure',
  PAYMENT_CONFIRM_FAILED: 'payment_confirm_failed',

  // New Razorpay Hook Events
  CHECKOUT_STARTED: 'checkout_started',
  RAZORPAY_SDK_NOT_READY: 'razorpay_sdk_not_ready',

  // Order Placed screen Tracking
  ORDER_PLACED_VIEW: 'order_placed_view',
  ORDER_PLACED_CONTINUE_CLICK: 'order_placed_continue_click',
  ORDER_PLACED_ACTION_CLICK: 'order_placed_action_click',

  // New Order Placed Events
  ORDER_PLACED_ITEM_VIEWED: 'order_placed_item_viewed',
  ORDER_PLACED_FALLBACK_CLICK: 'order_placed_fallback_click',
  ORDER_PLACED_LOAD_FAILED: 'order_placed_load_failed',
  ORDER_PLACED_FALLBACK_VIEW: 'order_placed_fallback_view',
} as const;

export const PROPERTIES = {
  CURATOR_NAME: 'curator_name',
  INSTAGRAM_ACCOUNT_NAME: 'instagram_account_name',
  POST_ID: 'post_id',
  CURATION_ID: 'curation_id',
  EXPERIMENT: 'experiment',
  DISTINCT_ID: 'distinct_id',

  // Custom Event Properties
  PRODUCT_ID: 'product_id',
  PRODUCT_NAME: 'product_name',
  PRICE: 'price',
  BRAND: 'brand',
  IS_AVAILABLE: 'is_available',
  HAS_SIZES: 'has_sizes',
  SELECTED_SIZE: 'selected_size',
  SIZE: 'size',
  VIDEO_ID: 'video_id',
  SECTION: 'section',
  IS_OPEN: 'is_open',
  AVAILABLE_SIZES: 'available_sizes',

  // Checkout and Order Properties
  GUEST_ORDER_ID: 'guest_order_id',
  ORDER_ID: 'order_id',
  STATUS: 'status',
  AMOUNT: 'amount',
  ITEM_COUNT: 'item_count',
  PAYMENT_MODE: 'payment_mode',
  PRODUCT_IDS: 'product_ids',
  ACTION: 'action',
  FAILURE_REASON: 'failure_reason',
  PAYMENT_ID: 'payment_id',

  // New Properties
  SOURCE: 'source',
  VIDEO_INDEX: 'video_index',
  VIDEO_URL: 'video_url',
  FROM_INDEX: 'from_index',
  TO_INDEX: 'to_index',
  TOTAL_SLIDES: 'total_slides',
  IMAGE_INDEX: 'image_index',
  IMAGE_URL: 'image_url',
  IS_PLAYING: 'is_playing',
  VIEW_DURATION_SECONDS: 'view_duration_seconds',
  COMPLETED: 'completed',
  USERNAME: 'username',
  RATING: 'rating',
  HAS_IMAGES: 'has_images',
  QUANTITY: 'quantity',
  TOTAL_REVIEWS: 'total_reviews',
  HAS_URL: 'has_url',
  PLATFORM: 'platform',
  IS_ZOOMED: 'is_zoomed',
  KEY: 'key',
  RID: 'rid',
  VARIANT: 'variant',
  FBCLID: 'fbclid',
  DECODED_CURATOR_NAME: 'decoded_curator_name',
  DECODED_INSTAGRAM_NAME: 'decoded_instagram_name',
  DECODED_POST_ID: 'decoded_post_id',
} as const;

export const TRACKING_SOURCES = {
  PDP_V2: 'pdpv2',
} as const;
